// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { cloudWithArrow16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-cloud-with-arrow': IconCloudWithArrow;
    }
}

/**
 * The icon component for the 'cloudWithArrow' icon
 */
export class IconCloudWithArrow extends Icon {
    public constructor() {
        super(cloudWithArrow16X16);
    }
}

registerIcon('icon-cloud-with-arrow', IconCloudWithArrow);
export const iconCloudWithArrowTag = 'nimble-icon-cloud-with-arrow';
